import store from 'app/store';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: ['admin', 'sub-admin', 'producer', 'sub-producer'],
    routes: [
        {
            path: '/base-transfers/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./BaseTransfersApp');
                        case 'producer':
                        case 'sub-producer':
                            return import('./ProducerBaseTransferApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
